module.exports = "/wp-content/plugins/farmacy/assets/js/images/stepIndicatorOrderReceivedDelivery-25ae5601c4d76297a05c285f99492933.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/cart/order-complete/img/stepIndicatorOrderReceivedDelivery.png
 ** module id = 564
 ** module chunks = 1 9 12 144
 **/